export default {
	VALIDATION_ERROR: 4001,
	PARSING_ERROR: 4002,
	SHORTCODE_NOT_FOUND_ERROR: 4003,
	SHARED_AGENT_NOT_FOUND_ERROR: 4004,

	INTERNAL_ERROR: 5001,
	AGENT_ALREADY_DEPLOYED_ERROR: 5002
}
